import createBrowserInfoParameters from './helpers/get-browser-info';
import validateLoginForm from './forms/login';
import postReopenAccountForm from './forms/reopen-account';

createBrowserInfoParameters('#login', 'login');
validateLoginForm('#login');
postReopenAccountForm('#login-reopen-account');
